







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import Incoming from '@finx/web-repository/src/apis/Incoming/Incoming'
import { toggleTheme, isDarkTheme } from '@/utils/theme'
import ConfiguracaoNotificacoesStore from '@/components/ConfiguracaoNotificacoes/Store/ConfiguracaoNotificacoesStore'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import FinanceiroCadastroResponsavelEmpresaMedica from '@/views/financeiro-cadastro-responsavel-empresa-medica.vue'
import Env from '@finx/web-repository/src/services/Env'
import Plans from '@finx/web-repository/src/constants/Plans'
import SegurancaApi from '@/Apis/Seguranca/Services/SegurancaApi'
import { isRolesValid, validateEmail, timeout, validateCPF, onlyNumber, isMobile, instrumentador, timeoutDefault } from '@/utils/common'
import { ConfiguracaoSecretaria, ConfiguracaoMedico, LocalAtendimento, StatusEmailEnum, TipoUsuarioEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import VueSignaturePad from 'vue-signature-pad'
import _ from 'lodash'
import { Medico } from '@/types/interfaces/Solicitacao'
import ConfiguracaoNotificacaoPerfil from '@/components/perfil/configuracao-notificacao-perfil.vue'

Vue.use(VueSignaturePad)

@Component({
  components: {
    FinanceiroCadastroResponsavelEmpresaMedica,
    ConfiguracaoNotificacaoPerfil,
  },
})
export default class ViewPerfil extends Vue {
  $refs!: {
    formEnviarEmail: any,
    formEnviarLocal: any,
    formConviteSecretaria: any,
    formCadastrarConviteSecretaria: any,
    tabs: any,
    signaturePad: any,
    formLocalAtendimento,
  }

  isInstrumentador(user: any) {
    return instrumentador(user)
  }

  async isSecretariaAmbulatorio() {
    if (this.isInstrumentador(this.$user.profile)) {
      const response = await this.getNotificacaoNotificacoesStore.getSecretariaInfo()
      if (response.success) {
        this.enableSecretariaAmbulatorio = _.toLower(this.getNotificacaoNotificacoesStore.secretaria.tipoUsuarioAgendamento)
          === _.toLower(TipoUsuarioEnum.SecretariaDoAmbulatorio)
      }
    }
  }

  medicoSelected: Medico = {
    id: '',
    nome: '',
    urlAssinatura: '',
  }

  secretariaAmbulatorio: boolean = false

  get enableSecretariaAmbulatorio() {
    return this.secretariaAmbulatorio
  }

  set enableSecretariaAmbulatorio(value: boolean) {
    this.secretariaAmbulatorio = value
  }

  assinatura: any = {}
  dialogUpdatePlan: Boolean = false
  equipeMedicaPagante: Boolean = false
  equipeMedicaNaoPagante: Boolean = false
  loadingGetAssinatura: Boolean = false
  usuarioPagante: Boolean = false
  usuarioNaoPagante: Boolean = false
  plan: any = {}
  planStaticInfo: any = {}
  showCards: Boolean = false
  showDadosCobrancaButton: Boolean = false
  showPaymentMethodButton: Boolean = true
  showValue: Boolean = true
  showingPlanDetails: Boolean = false
  subscriptionany = {}
  chatOff: boolean = false
  conf: boolean = false
  medicoEmailNotificacao: boolean = false
  medicoWhatsappNotificacao: boolean = false
  openLocal: boolean = false
  openEmail: boolean = false
  openRemoverLocal: boolean = false
  openRemoverSecretaria: boolean = false
  openRemoverEmail: boolean = false
  openConviteSecretaria: boolean = false
  fab: boolean = false
  enableConfiguracaoBtn: boolean = false
  novoLocal: string = ''
  novoEmail: string = ''
  loadLocal: boolean = false
  loadAddLocal: boolean = false
  loadLocalChecked: boolean = false
  loadEmailChecked: boolean = false
  loadConviteSecretaria: boolean = false
  load: boolean = false
  loadDeletarLocal: boolean = false
  loadDeletarSecretaria: boolean = false
  loadingDeletarEmail: boolean = false
  loadCpf: boolean = false
  loadAssociarSecretaria: boolean = false
  loadModalAssociarMedicoLocalAtendimento: boolean = false
  loadAssociarMedicoLocalAtendimento: boolean = false
  loadCloseAssociarMedicoLocalAtendimento: boolean = false
  cpfInicial: string = ''
  step: number = 1
  dialog: boolean = false
  conviteSecretariaTitle: string = 'Convite para secretária'
  loadAddEmail: string = ''
  local: string = ''
  emailMessage: string = ''
  loadTrocarAssinatura: boolean = false
  modalAssinatura: boolean = false
  assTabs: string = 'tab-1'
  canvasSz: number = 320
  loadSaveAssinatura: boolean = false
  penColor: string = 'rgb(51, 0, 133)'
  modalAssociarMedicoLocalAtendimento: boolean = false
  loadLocalByMedico: boolean = false
  locaisAtendimentoMedico: any[] = []
  loadOpenAssociarMedicoAtendimento: boolean = false
  loadClose: boolean = false

  showModalAssociarMedicoLocalAtendimentoClinica = false
  loadingOpenAssociarMedicoLocalAtendimentoClinica = false

  get isMedico() {
    const { pageAuthorized } = this.$user.profile || []
    return pageAuthorized.includes('agendamento-medico') || pageAuthorized.includes('agendamento-medico-ambulatorio')
  }

  get isExtratoContrato() {
    const { pageAuthorized } = this.$user.profile || []
    return pageAuthorized.includes('extrato-contrato')
  }

  // #region Noficacao configuracoes

  notificacaoConfiguracoesFilterValue = ''
  nofiticacaoConfiguracoesOptions: string[] = []
  filteredNofiticacaoConfiguracoes: ConfiguracaoMedico[] = []
  notificacacaoConfiguracoesPaginator = {
    total: 0,
    page: 1,
    pageLength: 100,
    // eslint-disable-next-line arrow-body-style
    pageNumbers: () => {
      return Math.ceil(this.notificacacaoConfiguracoesPaginator.total / this.notificacacaoConfiguracoesPaginator.pageLength)
    },
    buttonsLength: () => {
      if (this.$vuetify.breakpoint.smAndDown) return 4
      if (this.$vuetify.breakpoint.md) return 7
      if (this.$vuetify.breakpoint.lg) return 9
      return 10
    },
  }

  mapNotificacao(notificacao: ConfiguracaoMedico) {
    const celular = notificacao.notificacaoUsuario && notificacao.notificacaoUsuario.celular
    const recebeNotificacaoViaWhatsApp = notificacao.notificacaoUsuario && notificacao.notificacaoUsuario.recebeNotificacaoWhatsApp
    return {
      ...notificacao,
      celular,
      celularOriginal: celular,
      recebeNotificacaoViaWhatsApp,
      celularEditado: notificacao.celular || '',
      editandoCelular: false,
      salvandoCelular: false,
    }
  }


  filterNotificacaoConfiguracoes(resetPage = true) {
    let data = this.getNofiticacaoConfiguracoes

    this.notificacacaoConfiguracoesPaginator.total = data.length

    if (resetPage) {
      this.notificacacaoConfiguracoesPaginator.page = 1
    }

    const startPaginatedIndex = (this.notificacacaoConfiguracoesPaginator.page - 1) * this.notificacacaoConfiguracoesPaginator.pageLength
    const endPaginatedIndex = startPaginatedIndex + this.notificacacaoConfiguracoesPaginator.pageLength

    if (this.notificacaoConfiguracoesFilterValue) {
      data = data.filter(
        doctor => doctor.nome === this.notificacaoConfiguracoesFilterValue,
      )
      this.notificacacaoConfiguracoesPaginator.total = data.length
    }

    this.filteredNofiticacaoConfiguracoes = data
      .slice(startPaginatedIndex, endPaginatedIndex)
      .map(this.mapNotificacao)
  }

  loadNotificacaoConfiguracoesOptions() {
    const doctorsSet = new Set<string>()
    this.getNofiticacaoConfiguracoes.forEach(elem => (elem.nome ? doctorsSet.add(elem.nome) : null))

    this.nofiticacaoConfiguracoesOptions = Array.from(doctorsSet.values())
  }

  notificacacaoConfiguracoesPaginatorChange(page: number) {
    this.notificacacaoConfiguracoesPaginator.page = page
    this.filterNotificacaoConfiguracoes(false)
  }

  get canShowPaginatedNofiticacaoConfiguracoes() {
    return this.getNofiticacaoConfiguracoes.length > 1
  }

  get canShowNoPaginatedNofiticacaoConfiguracoes() {
    return this.getNofiticacaoConfiguracoes.length === 1
  }

  get canShowNotificacacaoConfiguracoesPaginator() {
    if (this.notificacaoConfiguracoesFilterValue) {
      return this.filteredNofiticacaoConfiguracoes.length > this.notificacacaoConfiguracoesPaginator.pageLength
    }

    return true
  }

  // #endregion Noficacao configuracoes

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingOpenAssociarMedicoAtendimento() {
    return this.loadOpenAssociarMedicoAtendimento
  }

  set loadingOpenAssociarMedicoAtendimento(value: boolean) {
    this.loadOpenAssociarMedicoAtendimento = value
  }

  get locaisDeAtendimentoDoMedico() {
    return this.locaisAtendimentoMedico
  }

  set locaisDeAtendimentoDoMedico(value: any[]) {
    this.locaisAtendimentoMedico = value
  }

  get loadingLocalByMedico() {
    return this.loadLocalByMedico
  }

  set loadingLocalByMedico(value: boolean) {
    this.loadLocalByMedico = value
  }

  get loadingAssociarMedicoLocalAtendimento() {
    return this.loadAssociarMedicoLocalAtendimento
  }

  set loadingAssociarMedicoLocalAtendimento(value: boolean) {
    this.loadAssociarMedicoLocalAtendimento = value
  }

  get loadingCloseAssociarMedicoLocalAtendimento() {
    return this.loadCloseAssociarMedicoLocalAtendimento
  }

  set loadingCloseAssociarMedicoLocalAtendimento(value: boolean) {
    this.loadCloseAssociarMedicoLocalAtendimento = value
  }

  get showModalAssociarMedicoLocalAtendimento() {
    return this.modalAssociarMedicoLocalAtendimento
  }

  set showModalAssociarMedicoLocalAtendimento(value: boolean) {
    this.modalAssociarMedicoLocalAtendimento = value
  }

  get loadingSaveAssinatura() {
    return this.loadSaveAssinatura
  }

  set loadingSaveAssinatura(value: boolean) {
    this.loadSaveAssinatura = value
  }

  get canvasSize() {
    return this.canvasSz
  }

  set canvasSize(value: number) {
    this.canvasSz = value
  }

  get assinaturaTabs() {
    return this.assTabs
  }

  set assinaturaTabs(value: string) {
    this.assTabs = value
  }

  get loadingTrocarAssinatura() {
    return this.loadTrocarAssinatura
  }

  set loadingTrocarAssinatura(value: boolean) {
    this.loadTrocarAssinatura = value
  }

  get showModalAssinatura() {
    return this.modalAssinatura
  }

  set showModalAssinatura(value: boolean) {
    this.modalAssinatura = value
  }

  get getMedicoSelecionado() {
    return this.getNotificacaoNotificacoesStore.medicoSelecionado
  }

  set getMedicoSelecionado(value: any) {
    this.getNotificacaoNotificacoesStore.setMedicoSelecionado(value)
  }

  get getLocaisAtendimentoHospital() {
    return this.getNotificacaoNotificacoesStore.locaisAtendimentosHospital
  }

  get getLocaisAtendimentoHospitalSelecionado() {
    return this.getNotificacaoNotificacoesStore.locaisAtendimentoHospitalSelecionado
  }

  set getLocaisAtendimentoHospitalSelecionado(value: any[]) {
    this.getNotificacaoNotificacoesStore.setLocaisAtendimentoHospitalSelecionado(value)
  }

  get locaisAtendimentoClinica() {
    return this.getNotificacaoNotificacoesStore.locaisAtendimentosClinica
  }

  get locaisAtendimentoClinicaSelecionado() {
    return this.getNotificacaoNotificacoesStore.locaisAtendimentoClinicaSelecionado
  }

  set locaisAtendimentoClinicaSelecionado(value: any[]) {
    this.getNotificacaoNotificacoesStore.setLocaisAtendimentoClinicaSelecionado(value)
  }

  get getMedicos() {
    return this.getNotificacaoNotificacoesStore.medicos
  }

  novoLocalMedico: any = {
    medicoId: '',
  }

  novoEmailMedico: any = {
    medicoId: '',
    localAtendimentoId: '',
  }

  removerSecretaria: any = {
    medicoId: '',
    secretariaId: '',
    localAtendimentoId: '',
  }

  removerLocal: any = {
    medicoId: '',
    localAtendimentoId: '',
  }

  removerEmail: any = {
    medicoId: '',
    localAtendimentoId: '',
    email: '',
  }

  snack: any = {
    show: false,
    text: '',
    icon: '',
    color: '',
  }

  get isMob() {
    return isMobile()
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get getNotificacaoNotificacoesStore() {
    return getModule(ConfiguracaoNotificacoesStore, this.$store)
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getNofiticacaoConfiguracoes() {
    return this.getNotificacaoNotificacoesStore.configuracaoNotificacoes
  }

  get getChatOff() {
    return this.chatOff
  }

  set getChatOff(value) {
    this.chatOff = value
  }

  get configuracoes() {
    return this.conf
  }

  set configuracoes(value: boolean) {
    this.conf = value
  }

  get getEnableConfiguracaoBtn() {
    return this.enableConfiguracaoBtn
  }

  set getEnableConfiguracaoBtn(value) {
    this.enableConfiguracaoBtn = value
  }

  get loadingRecebeEmailNotificacao() {
    return this.medicoEmailNotificacao
  }

  set loadingRecebeEmailNotificacao(value: boolean) {
    this.medicoEmailNotificacao = value
  }

  get loadingRecebeWhatsappNotificacao() {
    return this.medicoWhatsappNotificacao
  }

  set loadingRecebeWhatsappNotificacao(value: boolean) {
    this.medicoWhatsappNotificacao = value
  }

  get loadingAddEmail() {
    return this.loadAddEmail
  }

  set loadingAddEmail(value: string) {
    this.loadAddEmail = value
  }

  get addLocalLoading() {
    return this.loadAddLocal
  }

  set addLocalLoading(value: boolean) {
    this.loadAddLocal = value
  }

  get getNovoLocal() {
    return this.novoLocal
  }

  set getNovoLocal(value: string) {
    this.novoLocal = value
  }

  get getNovoEmail() {
    return this.novoEmail
  }

  set getNovoEmail(value: string) {
    this.novoEmail = value
  }

  get getLoadingLocalChecked() {
    return this.loadLocalChecked
  }

  set getLoadingLocalChecked(value: boolean) {
    this.loadLocalChecked = value
  }

  get getLoadingEmailChecked() {
    return this.loadEmailChecked
  }

  set getLoadingEmailChecked(value: boolean) {
    this.loadEmailChecked = value
  }

  get getLoadingConviteSecretaria() {
    return this.loadConviteSecretaria
  }

  set getLoadingConviteSecretaria(value: boolean) {
    this.loadConviteSecretaria = value
  }

  get getLoading() {
    return this.load
  }

  set getLoading(value: boolean) {
    this.load = value
  }

  get localLoading() {
    return this.loadLocal
  }

  set localLoading(value: boolean) {
    this.loadLocal = value
  }

  get getLoadingDeletarLocal() {
    return this.loadDeletarLocal
  }

  set getLoadingDeletarLocal(value: boolean) {
    this.loadDeletarLocal = value
  }

  get getLoadingDeletarSecretaria() {
    return this.loadDeletarSecretaria
  }

  set getLoadingDeletarSecretaria(value: boolean) {
    this.loadDeletarSecretaria = value
  }

  get getLoadingDeletarEmail() {
    return this.loadingDeletarEmail
  }

  set getLoadingDeletarEmail(value: boolean) {
    this.loadingDeletarEmail = value
  }

  get getLoadingCpf() {
    return this.loadCpf
  }

  set getLoadingAssociarSecretaria(value: boolean) {
    this.loadAssociarSecretaria = value
  }

  get getLoadingAssociarSecretaria() {
    return this.loadAssociarSecretaria
  }

  set getLoadingCpf(value: boolean) {
    this.loadCpf = value
  }

  get snackbar() {
    return this.snack
  }

  set snackbar(value: any) {
    this.snack = value
  }

  get getConviteSecretaria() {
    return this.getNotificacaoNotificacoesStore.conviteSecretaria
  }

  get getCpfInicial() {
    return this.cpfInicial
  }

  set getCpfInicial(value: string) {
    this.cpfInicial = value
  }

  get getStep() {
    return this.step
  }

  set getStep(value: number) {
    this.step = value
  }

  get getConviteSecretariaTitle() {
    return this.conviteSecretariaTitle
  }

  set getConviteSecretariaTitle(value: string) {
    this.conviteSecretariaTitle = value
  }

  enviarLocalRules: any = {
    valid: false,
    localRules: [
      v => !!v || 'O campo Local de Atendimento é obrigatório.',
    ],
  }

  enviarEmailRules: any = {
    valid: false,
    emailRules: [
      v => !!v || 'O campo E-mail é obrigatório.',
      v => this.validarEmail(v) || 'O e-mail deve ser válido.',
    ],
  }

  enviarConviteSecretariaRules: any = {
    valid: false,
    nomeRules: [
      v => !!v || 'O campo Nome da secretária é obrigatório.',
    ],
    emailRules: [
      v => !!v || 'O campo E-mail é obrigatório.',
      v => this.validarEmail(v) || 'O e-mail deve ser válido.',
    ],
  }

  verifySecretariaRules: any = {
    valid: false,
    cpfRules: [
      v => !!v || 'O campo CPF é obrigatório.',
      v => validateCPF(v) || 'Cpf inválido.',
    ],
  }

  localAtendimentoRules: any = {
    valid: false,
    medico: [
      v => (!!v) || 'O campo médico é obrigatório.',
    ],
    locaisAtendimento: [
      v => (!!v && v.length > 0) || 'O campo local de atendimento é obrigatório.',
    ],
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async openAssociarMedicoLocalAtendimentoClinica() {
    this.loadingOpenAssociarMedicoLocalAtendimentoClinica = true
    await this.getNotificacaoNotificacoesStore.getMedicos()
    this.showModalAssociarMedicoLocalAtendimentoClinica = true
    this.loadingOpenAssociarMedicoLocalAtendimentoClinica = false
  }

  async closeModalAssociarMedicoLocalAtendimentoClinica() {
    this.getNotificacaoNotificacoesStore.clearLocaisAtendimento()
    this.showModalAssociarMedicoLocalAtendimentoClinica = false
    this.$refs.formLocalAtendimento.reset()
  }

  async openAssociarMedicoLocalAtendimento() {
    this.loadingOpenAssociarMedicoAtendimento = true
    await this.getNotificacaoNotificacoesStore.getMedicos()
    this.showModalAssociarMedicoLocalAtendimento = true
    this.loadingOpenAssociarMedicoAtendimento = false
  }

  async associarMedicoLocaisAtendimento() {
    this.loadingAssociarMedicoLocalAtendimento = true
    if (this.$refs.formLocalAtendimento.validate()) {
      const response = await this.getNotificacaoNotificacoesStore.associarMedicoLocaisAtendimento()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Foi adicionado um novo local de atendimento!', icon: 'done', color: '#2E7D32' })
        await timeoutDefault()
        this.closeModalAssociarMedicoLocalAtendimento()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingAssociarMedicoLocalAtendimento = false
  }

  async associarMedicoLocaisAtendimentoClinica() {
    this.loadingAssociarMedicoLocalAtendimento = true
    if (this.$refs.formLocalAtendimento.validate()) {
      const response = await this.getNotificacaoNotificacoesStore.associarMedicoLocaisAtendimentoClinica()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Foi adicionado um novo local de atendimento!', icon: 'done', color: '#2E7D32' })
        await timeoutDefault()
        this.closeModalAssociarMedicoLocalAtendimentoClinica()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingAssociarMedicoLocalAtendimento = false
  }

  removeLocalAtendimentoHospital(item: any) {
    this.getNotificacaoNotificacoesStore.removeLocalAtendimentoHospital(item)
  }

  removeLocalAtendimentoClinica(item: any) {
    this.getNotificacaoNotificacoesStore.removeLocalAtendimentoClinica(item)
  }

  async closemodalAssociarMedicoLocalAtendimentoBtn() {
    this.loadingCloseAssociarMedicoLocalAtendimento = true
    await timeoutDefault()
    this.closeModalAssociarMedicoLocalAtendimento()
    this.loadingCloseAssociarMedicoLocalAtendimento = false
  }

  async closeModalAssociarMedicoLocalAtendimentoEsc() {
    this.loadingClose = true
    await timeoutDefault()
    this.closeModalAssociarMedicoLocalAtendimento()
    this.loadingClose = false
  }

  async closeModalAssociarMedicoLocalAtendimento() {
    this.getNotificacaoNotificacoesStore.clearLocaisAtendimento()
    this.showModalAssociarMedicoLocalAtendimento = false
    this.$refs.formLocalAtendimento.reset()
  }

  async getLocalByMedico() {
    this.loadingLocalByMedico = true
    this.getNotificacaoNotificacoesStore.clearLocaisAtendimentoHospitalSelecionado()
    await this.getNotificacaoNotificacoesStore.getLocaisAtendimentoHospitalByMedicoId()
    this.loadingLocalByMedico = false
  }

  async getLocalClinicaByMedico() {
    this.loadingLocalByMedico = true
    this.getNotificacaoNotificacoesStore.clearLocaisAtendimentoClinicaSelecionado()
    await this.getNotificacaoNotificacoesStore.getLocaisAtendimentoClinicaByMedicoId()
    this.loadingLocalByMedico = false
  }

  async showOpenModalLocal(medico: ConfiguracaoMedico) {
    this.addLocalLoading = true
    await timeout(1500)
    this.openLocal = true
    this.novoLocalMedico = {
      medicoId: medico.id,
    }

    this.addLocalLoading = false
  }

  async showModalOpenEmail(medico: ConfiguracaoMedico, localAtendimentoId: string) {
    this.loadingAddEmail = localAtendimentoId
    await timeout(500)
    this.openEmail = true
    this.novoEmailMedico = {
      medicoId: medico.id,
      localAtendimentoId,
    }
    this.loadingAddEmail = ''
  }

  closeConfiguracoes() {
    this.configuracoes = false
  }

  closeModalLocal() {
    this.openLocal = false
    this.local = ''
    this.getNovoLocal = ''
    this.$refs.formEnviarLocal.reset()
  }

  closeModalEmail() {
    this.openEmail = false
    this.emailMessage = ''
    this.novoEmailMedico = { medicoId: '', localAtendimentoId: '' }
    this.$refs.formEnviarEmail.reset()
  }

  closeModalRemoverLocal() {
    this.openRemoverLocal = false
    this.removerLocal = { medicoId: '', localAtendimentoId: '' }
  }

  closeModalRemoverSecretaria() {
    this.openRemoverSecretaria = false
  }

  closeModalRemoverEmail() {
    this.openRemoverEmail = false
  }

  closeModalConviteSecretaria() {
    this.openConviteSecretaria = false
    this.getStep = 1
    this.$refs.formConviteSecretaria.reset()
  }

  async adicionarLocal() {
    this.getLoadingLocalChecked = true

    const params: any = {
      medicoId: this.novoLocalMedico.medicoId,
      LocalAtendimentoNome: this.getNovoLocal,
    }

    const request = await this.getNotificacaoNotificacoesStore.adicionaMedicoLocalAtendimento(params)
    if (request) {
      this.novoLocalMedico = { medicoId: '' }
      this.closeModalLocal()
      await this.getNotificacaoNotificacoesStore.getConfiguracoes()
      EventBus.$emit('setSnackbar', { show: true, text: 'Novo local adicionado!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
    }

    this.getLoadingLocalChecked = false
  }

  async adicionarEmail() {
    this.getLoadingEmailChecked = true
    const params: any = {
      userId: this.$user.profile.sub,
      medicoId: this.novoEmailMedico.medicoId,
      localAtendimentoId: this.novoEmailMedico.localAtendimentoId,
      email: this.getNovoEmail,
    }

    const emailChecked = this.validarEmail(this.getNovoEmail)

    if (emailChecked) {
      const response = await this.getNotificacaoNotificacoesStore.adicionarEmail(params)

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'E-mail enviado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.openRemoverSecretaria = false
        this.openEmail = false
        this.$refs.formEnviarEmail.reset()
        this.novoEmailMedico = { medicoId: '', localAtendimentoId: '' }
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
      }
    }

    this.getLoadingEmailChecked = false
  }

  getPlanStaticInfo(plano) {
    const planoNome = plano.plano
    // @ts-ignore
    Plans.map((plan) => {
      if (plan.nome === planoNome) this.planStaticInfo = plan
      return plan
    })
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  setTypeUser(subscription) {
    if (subscription.planos && subscription.planos.length > 1) {
      if (subscription.usuarioPagante) this.equipeMedicaPagante = true
      else this.equipeMedicaNaoPagante = true
    } else if (subscription.usuarioPagante) {
      this.usuarioPagante = true
    } else {
      this.usuarioNaoPagante = true
    }

    this.checkPaymentMethodButton(subscription)
  }

  checkPaymentMethodButton(subscription) {
    if (this.usuarioPagante) {
      if (!subscription.valorTotal) {
        this.showPaymentMethodButton = false
        this.showDadosCobrancaButton = false
        this.showValue = false
      }

      if (subscription.tipoAssinatura === 'Free') {
        this.showPaymentMethodButton = false
        this.showDadosCobrancaButton = false
        this.showValue = false
      }
    }

    if (this.usuarioNaoPagante) {
      this.showPaymentMethodButton = false
      this.showDadosCobrancaButton = false
      this.showValue = false
    }

    if (this.equipeMedicaPagante) {
      if (!subscription.valorTotal) {
        this.showPaymentMethodButton = false
        this.showDadosCobrancaButton = false
        this.showValue = false
      }

      if (subscription.tipoAssinatura === 'Free') {
        this.showPaymentMethodButton = false
        this.showDadosCobrancaButton = false
        this.showValue = false
      }
    }

    if (this.equipeMedicaNaoPagante) {
      this.showPaymentMethodButton = false
      this.showDadosCobrancaButton = false
      this.showValue = false
    }
  }

  isDark: boolean = isDarkTheme()

  get podePersonificar(): boolean {
    const user = this.$user
    const authorized = user && user.profile && Array.isArray(user.profile.pageAuthorized)
      ? user.profile.pageAuthorized
      : []
    const hasPermission = authorized.includes('suporte-personificar')
    const isImpersonating = sessionStorage.getItem('IMPERSONATION_ACTIVE') === 'true'
    return hasPermission || isImpersonating
  }

  alternarTema() {
    toggleTheme()
    this.isDark = isDarkTheme()
  }

  logout(): void {
    this.$router.push('/logout')
  }

  trocarSenha(): void {
    this.ga('autenticacao', 'alterar-senha')
    window.location.href = `${Env.KEYCLOAK_AUTHORITY_URL}/realms/${Env.KEYCLOAK_REALM}/login-actions/reset-credentials?client_id=${Env.KEYCLOAK_CLIENT_ID}&redirect_uri=${Env.CLIENT_ADDRESS}`
  }

  async showModalCadastroResponsavelEmpresaMedica() {
    await this.getRecebimentoStore.getDadosContratoEGestores()
    this.getRecebimentoStore.setModalCadastroEmpresaMedicaResponsavel(true)
  }

  get assinaturaMedico() {
    return this.getNotificacaoNotificacoesStore.assinaturaMedico
  }

  set assinaturaMedico(value: string) {
    this.getNotificacaoNotificacoesStore.setAssinaturaMedico(value)
  }

  async trocarAssinatura() {
    this.loadingTrocarAssinatura = true
    await this.getNotificacaoNotificacoesStore.getAssinaturaDoMedico()
    if (this.$refs.tabs) this.$refs.tabs.onResize()
    this.showModalAssinatura = true
    this.loadingTrocarAssinatura = false
  }

  closeModalAssinatura() {
    this.assinaturaTabs = 'tab-1'
    this.showModalAssinatura = false
  }

  cropSignatureCanvas(canvas) {
    // @ts-ignore
    const croppedCanvas: HTMLCanvasElement = document.createElement('canvas')
    // @ts-ignore
    const croppedCtx: CanvasRenderingContext2D = croppedCanvas.getContext('2d')

    croppedCanvas.width = canvas.width
    croppedCanvas.height = canvas.height
    croppedCtx.drawImage(canvas, 0, 0)

    let w = croppedCanvas.width
    let h = croppedCanvas.height
    const pix = { x: [], y: [] }
    const imageData = croppedCtx.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height)
    let index: number = 0

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        index = (y * w + x) * 4
        if (imageData.data[index + 3] > 0) {
          // @ts-ignore
          pix.x.push(x)
          // @ts-ignore
          pix.y.push(y)
        }
      }
    }

    pix.x.sort((a, b) => a - b)
    pix.y.sort((a, b) => a - b)
    const n = pix.x.length - 1

    w = pix.x[n] - pix.x[0]
    h = pix.y[n] - pix.y[0]
    const cut = croppedCtx.getImageData(pix.x[0], pix.y[0], w, h)

    croppedCanvas.width = w
    croppedCanvas.height = h
    croppedCtx.putImageData(cut, 0, 0)

    return croppedCanvas.toDataURL()
  }

  onBegin() {
    this.$refs.signaturePad.resizeCanvas()
  }

  @Watch('assinaturaTabs')
  onChangeAssinaturaTabs(n, o) {
    if (n === 'tab-1') {
      this.$nextTick(() => {
        this.$refs.signaturePad.clearSignature()
        this.$refs.signaturePad.clearCacheImages()
      })
    }
  }

  undo() {
    this.$refs.signaturePad.undoSignature()
  }

  async save() {
    this.loadingSaveAssinatura = true
    const { isEmpty } = this.$refs.signaturePad.saveSignature()
    if (isEmpty) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma assinatura foi feita.', icon: 'warning', color: '#C62828', timeout: 2000 })
    } else {
      const canvas = document.getElementsByTagName('canvas')[0]
      const image = this.cropSignatureCanvas(canvas)
      const request = await this.getNotificacaoNotificacoesStore.updateAssinaturaDoMedico({ assinatura: (image as String).substring(22, image.length) })
      if (request.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Assinatura atualizada com sucesso!', icon: 'done', color: '#2E7D32' })
        this.assinaturaTabs = 'tab-1'
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro ao atualizar a assinatura.', icon: 'warning', color: '#C62828', timeout: 2000 })
        this.$nextTick(() => {
          this.$refs.signaturePad.clearSignature()
          this.$refs.signaturePad.clearCacheImages()
        })
      }
    }
    this.loadingSaveAssinatura = false
  }

  async openConfiguracoes() {
    this.getLoading = true
    await this.getNotificacaoNotificacoesStore.getConfiguracoes()
    this.loadNotificacaoConfiguracoesOptions()
    this.filterNotificacaoConfiguracoes()
    this.configuracoes = true
    this.getLoading = false
  }

  openModalConfirmarDeletarLocal(medicoId: string, localAtendimentoId: string) {
    this.removerLocal = {
      medicoId,
      localAtendimentoId,
    }
    this.openRemoverLocal = true
  }

  openModalConfirmarDeletarSecretaria(medicoId: string, localAtendimentoId: string, secretariaId: string) {
    this.removerSecretaria = {
      medicoId,
      localAtendimentoId,
      secretariaId,
    }
    this.openRemoverSecretaria = true
  }

  openModalConfirmarDeletarEmail(medicoId: string, localAtendimentoId: string, email: string) {
    this.removerEmail = {
      medicoId,
      localAtendimentoId,
      email,
    }
    this.openRemoverEmail = true
  }

  async deletarLocal() {
    this.getLoadingDeletarLocal = true

    const response = await this.getNotificacaoNotificacoesStore.removeMedicoLocalAtendimento(this.removerLocal)
    if (response.success) {
      this.removerSecretaria = {
        medicoId: '',
        localAtendimentoId: '',
      }
      await this.getNotificacaoNotificacoesStore.getConfiguracoes()
      this.filterNotificacaoConfiguracoes()
      this.openRemoverLocal = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Local de atendimento deletado com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
    }

    this.getLoadingDeletarLocal = false
  }

  async deletarSecretaria() {
    this.getLoadingDeletarSecretaria = true
    const response = await this.getNotificacaoNotificacoesStore.deletarSecretaria(this.removerSecretaria)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Secretaria deletada com sucesso!', icon: 'done', color: '#2E7D32' })
      this.openRemoverSecretaria = false
      this.removerSecretaria = {
        medicoId: '',
        localAtendimentoId: '',
        secretariaId: '',
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro no envio.', icon: 'warning', color: '#C62828', timeout: 5800 })
    }

    this.getLoadingDeletarSecretaria = false
  }

  async deletarEmail() {
    this.getLoadingDeletarEmail = true
    const response = await this.getNotificacaoNotificacoesStore.deletarEmail(this.removerEmail)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'E-mail deletado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.openRemoverEmail = false
      this.removerEmail = {
        medicoId: '',
        localAtendimentoId: '',
        email: '',
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro no envio.', icon: 'warning', color: '#C62828', timeout: 5800 })
    }

    this.getLoadingDeletarEmail = false
  }

  async visualizarAmbulatorioHospital(secretaria: ConfiguracaoSecretaria) {
    const tempSecretaria = secretaria
    tempSecretaria.loading = true
    const params: any = {
      userId: this.$user.profile.sub,
      secretariaId: tempSecretaria.id,
      visualizaSolicitacaoAmbulatorio: tempSecretaria.visualizaSolicitacaoAmbulatorio,
    }

    const response = await this.getNotificacaoNotificacoesStore.atualizaSecretariaVisualizaSolicitacoesAmbulatorio(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Perfil da secretaria atualizada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
      tempSecretaria.visualizaSolicitacaoAmbulatorio = !tempSecretaria.visualizaSolicitacaoAmbulatorio
    }

    tempSecretaria.loading = false
  }

  validarEmail(email) {
    return validateEmail(email)
  }

  async checkEmail(email: string) {
    let isValid: boolean = false
    this.getLoading = true
    if (validateEmail(email)) {
      const getByLoginResponse = await SegurancaApi.getByLogin(email)

      if (getByLoginResponse.success) {
        if (getByLoginResponse.data && getByLoginResponse.data.id) {
          isValid = false
          EventBus.$emit('setSnackbar', { show: true, text: 'E-mail já cadastrado.', icon: 'warning', color: '#C62828' })
        } else {
          isValid = true
          this.emailMessage = ''
        }
      } else {
        isValid = false
        EventBus.$emit('setSnackbar', { show: true, text: getByLoginResponse.message || 'E-mail inválido.', icon: 'warning', color: '#C62828' })
      }
    } else {
      this.emailMessage = 'O e-mail deve ser válido.'
    }
    this.getLoading = false
    return isValid
  }

  async sendAlert(url?: String, status?: string, data?, headers?) {
    const detail = `
      URL: ${url}
      Código: ${status}
      Usuário: ${this.$user.profile.email}
      Data: ${JSON.stringify(data)}
      Headers: ${JSON.stringify(headers)}
    `
    const message = {
      title: 'Erro na API',
      text: detail,
      themeColor: 'red',
    }

    Incoming.Alert.sendAlert(message)
  }

  convidarSecretaria(notificacao: ConfiguracaoMedico, localAtendimento: LocalAtendimento) {
    if (!notificacao.medicoTemUsuario) {
      EventBus.$emit('setSnackbar', { show: true, text: 'É necessário que o médico possua login na Fin-X. Para isso é necessário o envio do convite para ser realizado o cadastro.', icon: 'warning', color: '#C62828' })
      return
    }

    this.getNotificacaoNotificacoesStore.conviteSecretaria.medicoId = notificacao.id
    this.getNotificacaoNotificacoesStore.conviteSecretaria.localAtendimentoId = localAtendimento.id || ''
    this.getNotificacaoNotificacoesStore.conviteSecretaria.localAtendimentoNome = localAtendimento.nome || ''
    this.getNotificacaoNotificacoesStore.conviteSecretaria.nomeMedico = notificacao.nome
    this.openConviteSecretaria = true
  }

  async verifyCPF() {
    this.$refs.formCadastrarConviteSecretaria.reset()
    if (this.$refs.formConviteSecretaria.validate()) {
      this.getLoadingCpf = true
      this.getNotificacaoNotificacoesStore.conviteSecretaria.cpf = this.getCpfInicial
      const response = await this.getCadastroMedicoStore.checkSecretariaCpf(this.cpfInicial)
      if (response.success) {
        switch (response.data.checkSecretariaStatus) {
          case 'AssociarConta':
            this.getNotificacaoNotificacoesStore.setSecretariaExistente(response.data)
            this.getConviteSecretariaTitle = 'Conta encontrada para este CPF!'
            this.getStep = 2
            break
          case 'ContinuarCadastro':
            this.getConviteSecretariaTitle = 'Dados da secretária'
            this.getStep = 3
            break
          default:
            EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
            break
        }
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
      this.getLoadingCpf = false
    }
  }

  async enviarConviteSecretaria() {
    this.getLoadingConviteSecretaria = true
    const emailChecked = await this.checkEmail(this.getConviteSecretaria.email)

    if (emailChecked) {
      const response = await this.getNotificacaoNotificacoesStore.sendConvite()

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Convite enviado com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.getNotificacaoNotificacoesStore.getConfiguracoes()
        this.getNotificacaoNotificacoesStore.clearConviteSecretaria()
        this.$refs.formCadastrarConviteSecretaria.reset()
        this.$refs.formConviteSecretaria.reset()
        this.openConviteSecretaria = false
        this.getStep = 1
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'E-mail inválido.', icon: 'warning', color: '#C62828' })
    }

    this.getLoadingConviteSecretaria = false
  }

  async associarSecretaria() {
    this.getLoadingAssociarSecretaria = true
    const response = await this.getNotificacaoNotificacoesStore.associarContaSecretaria()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Secretaria associada com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getNotificacaoNotificacoesStore.clearConviteSecretaria()
      this.$refs.formConviteSecretaria.reset()
      await this.getNotificacaoNotificacoesStore.getConfiguracoes()
      this.openConviteSecretaria = false
      this.getStep = 1
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro no envio.', icon: 'warning', color: '#C62828' })
    }

    this.getLoadingAssociarSecretaria = false
  }

  async mounted() {
    await this.isSecretariaAmbulatorio()
    this.getEnableConfiguracaoBtn = isRolesValid(this.$user.profile, 'agendamentoSecretariaNotificacao')
    this.getChatOff = !isRolesValid(this.$user.profile, 'chatOff')
  }
}
